import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../../artzu-ui/src/Button';

const Heading = ({ header, price, notes, image, icon, appFormat }) => (
  <div className="autzu-fleets-heading__container">
    <div className="autzu-fleets-heading__content">
      <div className="autzu-fleets-heading__column">
        <h1> {header} </h1>
        <div className="autzu-fleets-heading__subheader--starting">
          Starting at
        </div>
        <h4 className="autzu-fleets-heading__subheader autzu-fleets-heading__subheader--plus">
          <div className="nyc-vehicle-types__subheader--rate">$7</div>
          <div className="nyc-vehicle-types__subheader--hr">/hr</div>
        </h4>
        {notes.map((note, index) => (
          <div className="autzu-fleets-heading__bulletContainer">
            <div
              key={`item${index}`}
              className="autzu-fleets-heading__noteEV">
              {icon}{' '}
            </div>
            <div
              key={`item${index}`}
              className="autzu-fleets-heading__note">
              {note}{' '}
            </div>
          </div>
        ))}
        {appFormat ? null : (
          <Link
            to="/signup"
            className="autzu-fleets-heading__buttonContainer">
            <Button
              label="Sign Up"
              primary
              color="#128DFF"
              size="xl"
              className="autzu-fleets-heading__button--toronto"
              id="autzu-fleets-heading__button--toronto"
            />
          </Link>
        )}
      </div>
      <div className="autzu-fleets-heading__column">
        <img
          className="autzu-fleets-heading__image"
          alt="vehicle"
          src={image}
        />
      </div>
    </div>
  </div>
);

export default Heading;



// WEBPACK FOOTER //
// ./src/components/Static/SFFleets/Shared/Heading.js